import { render, staticRenderFns } from "./tabObjectBalance.vue?vue&type=template&id=45d75c13&"
import script from "./tabObjectBalance.vue?vue&type=script&lang=js&"
export * from "./tabObjectBalance.vue?vue&type=script&lang=js&"
import style0 from "./tabObjectBalance.vue?vue&type=style&index=0&id=45d75c13&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports